import { useMemo } from 'react';
import { ConcreteColumnDefinitionData } from '../queues/column-definition.enum';
import { useQueueStore } from '../queues/context/use-queue-store';

const COLUMNS = ['CALL_SIGN', 'UNIT_DISPATCH_AREA', 'STATUS', 'UNIT_BEAT', 'MINUTES_IN_STATUS'];

export function useUnitsSortColumns(): ConcreteColumnDefinitionData[] {
    const store = useQueueStore();

    return useMemo(() => {
        return store.workspacePanel.queue.availableColumns.filter((column) => {
            return COLUMNS.includes(column.name);
        });
    }, [store]);
}
